import { DatabaseFieldType } from '@databases/types/database';
import { type MessageDescriptor } from 'react-intl-next';

import { messages } from '../messages';

export interface AllowMultiToggleMessages {
  labelMessage: MessageDescriptor;
  tooltipMessage?: MessageDescriptor;
}

export const getAllowMultiToggleMessages = (
  fieldType: DatabaseFieldType
): AllowMultiToggleMessages | null => {
  switch (fieldType) {
    case DatabaseFieldType.SELECT:
      return {
        labelMessage: messages.allowMultiToggleLabelTags,
        tooltipMessage: messages.allowMultiToggleTooltipTags
      };

    case DatabaseFieldType.USER:
      return {
        labelMessage: messages.allowMultiToggleLabelUsers,
        tooltipMessage: messages.allowMultiToggleTooltipUsers
      };

    case DatabaseFieldType.HYPERLINK:
    case DatabaseFieldType.PAGE_LINK:
    case DatabaseFieldType.ENTRY_LINK:
    case DatabaseFieldType.JIRA_ISSUE:
      return {
        labelMessage: messages.allowMultiToggleLabelLinks
      };

    default:
      return null;
  }
};
